import React from "react";
import { Spinner } from "@genie-ui/react";
import "./SearchLoader.scss";

const SearchLoader = () => {
  return (
    <div className="input-root__loader">
      <Spinner />
    </div>
  );
};

export default SearchLoader;
